import { RAW_cssValue } from "@classdojo/web/nessie/stylingLib/RawCssValue";
import FullBleedSetup from "./FullBleedSetup";

/**
 * Implementation for the fixed header + scrolling content pattern. Accounts for extra top and bottom
 * space necessary to avoid iPhone notch and status bar
 */

type FixedHeaderScrollerProps = {
  headerBackground?: string;
  contentBackground?: string;
  header: React.ReactNode;
  children: React.ReactNode;
};

export default function FixedHeaderScroller({
  headerBackground,
  contentBackground,
  header,
  children,
}: FixedHeaderScrollerProps) {
  return (
    <FullBleedSetup>
      <div sx={{ display: "flex", flexDirection: "column", position: "relative" }}>
        {/* Header */}
        <div
          sx={{
            paddingTop: RAW_cssValue("env(safe-area-inset-top)"),
            background: headerBackground,
            position: "relative",
          }}
        >
          {header}
        </div>

        {/* Main content */}
        <div
          sx={{
            flexGrow: 1,
            paddingBottom: RAW_cssValue("env(safe-area-inset-bottom)"),
            overflow: "auto",
            background: contentBackground,
            position: "relative",
          }}
        >
          {children}
        </div>
      </div>
    </FullBleedSetup>
  );
}
